import { FC } from "react";

import type { SuggestedPrompt } from "./constants";
import SuggestedPromptCard from "./SuggestedPromptCard";

type Props = {
  prompts: SuggestedPrompt[];
  onSelect: (prompt: SuggestedPrompt) => void;
  disabled?: boolean;
};

const SuggestedPrompts: FC<Props> = ({ prompts, onSelect, disabled }) => (
  <section aria-labelledby="agentic-ai-suggested-prompts" className="w-full">
    <div
      id="agentic-ai-suggested-prompts"
      className="mb-6 text-base font-bold text-txtHeading"
    >
      Suggested prompts
    </div>
    <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {prompts.map((prompt) => (
        <li key={prompt.id}>
          <SuggestedPromptCard
            title={prompt.title}
            description={prompt.description}
            icon={prompt.icon}
            disabled={disabled}
            onSelect={() => onSelect(prompt)}
          />
        </li>
      ))}
    </ul>
  </section>
);

export default SuggestedPrompts;
